// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indeterminate-progress-bar-container-plnPR {
  height: 4px;
  background-color: #FCC8C8;
  overflow: hidden;
}

.indeterminate-progress-bar-progress-rDTo6 {
  width: 100%;
  height: 100%;
  background-color: var(--accent-color);
  animation: indeterminate-progress-bar-animation-DlpFs 1s infinite linear;
  transform-origin: 0% 50%;
}

@keyframes indeterminate-progress-bar-animation-DlpFs {
  0% {
    transform:  translateX(0) scaleX(0);
  }
  40% {
    transform:  translateX(0) scaleX(0.4);
  }
  100% {
    transform:  translateX(100%) scaleX(0.5);
  }
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/indeterminate-progress-bar/indeterminate-progress-bar.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,wEAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,wCAAwC;EAC1C;AACF","sourcesContent":[".container {\n  height: 4px;\n  background-color: #FCC8C8;\n  overflow: hidden;\n}\n\n.progress {\n  width: 100%;\n  height: 100%;\n  background-color: var(--accent-color);\n  animation: animation 1s infinite linear;\n  transform-origin: 0% 50%;\n}\n\n@keyframes animation {\n  0% {\n    transform:  translateX(0) scaleX(0);\n  }\n  40% {\n    transform:  translateX(0) scaleX(0.4);\n  }\n  100% {\n    transform:  translateX(100%) scaleX(0.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `indeterminate-progress-bar-container-plnPR`,
	"progress": `indeterminate-progress-bar-progress-rDTo6`,
	"animation": `indeterminate-progress-bar-animation-DlpFs`
};
export default ___CSS_LOADER_EXPORT___;
